import { useState } from 'react'

import { Button, useToggle } from '@factorialco/deprecated-design-system'
import { Box, Text } from '@factorialco/deprecated-design-system'
import { PermissionsGroupExternalsPageItemFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import Popover from 'modules/core/components/Popover'
import type { Option } from 'modules/core/components/Popover/Content'
import PopoverContent from 'modules/core/components/Popover/Content'
import UserAvatar from 'modules/core/components/UserAvatar'
import i18n from 'modules/core/lib/i18n'

import EditUserModal from 'modules/external_users/components/EditUserModal'
import ChangeGroupModal from 'modules/permissions/components/ChangeGroupModal'

interface Props {
  user: PermissionsGroupExternalsPageItemFragment
  canAssign: boolean
  canEdit: boolean
  onUpdate: () => void
}

const Item = ({ user, canAssign, canEdit, onUpdate }: Props) => {
  const [editModalOpen, setEditModalOpen] = useState(false)
  const [changeGroupModalOpen, setChangeGroupModalOpen] = useState(false)
  const [open, toggle] = useToggle(false)

  const options = () => {
    const allowedOptions: Option[] = []

    if (canAssign) {
      allowedOptions.push({
        title: i18n.t('settings.permissions.group.change_group'),
        onClick: () => {
          setChangeGroupModalOpen(true)
        },
      })
    }

    if (canEdit) {
      allowedOptions.push({
        title: i18n.t('settings.permissions.users.edit'),
        onClick: () => {
          setEditModalOpen(true)
        },
      })
    }

    return allowedOptions
  }

  return (
    <Box
      width="full"
      flexDirection="row"
      padding="s16"
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey200',
        },
      }}
      alignItems="center"
    >
      <Box width="full" flexDirection="row" gap="s16" alignItems="center">
        <UserAvatar user={user} />
        <Box width="full">
          <Text size="400" weight="normal" color="grey1000">
            {user.fullName}
          </Text>
          <Text size="300" weight="normal" color="grey600">
            {user.email}
          </Text>
        </Box>
      </Box>
      {options().length > 0 && (
        <Popover
          attachment="top right"
          targetAttachment="bottom center"
          toggle={toggle}
          open={open}
        >
          <Button type="secondary" onClick={toggle(true)} iconName="ellipsis" />
          <PopoverContent onClose={toggle(false)} options={options()} />
        </Popover>
      )}
      {editModalOpen && <EditUserModal userId={user.id} onClose={() => setEditModalOpen(false)} />}
      {changeGroupModalOpen && (
        <ChangeGroupModal
          userId={user.id}
          firstName={user.firstName}
          lastName={user.lastName}
          onClose={() => {
            setChangeGroupModalOpen(false)
            onUpdate()
          }}
        />
      )}
    </Box>
  )
}

export default observer(Item)
